module.exports = __webpack_public_path__ + "static/media/Slider 1 2.4d35c728.jpg";